import map from "lodash/map";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Table from "../../Common/Tables/BaseTable";
import RettekoderModal from "./UpdateModals/RettekoderModal";

import { getRettekoder } from "../../../actions/rettekoderActions";
import * as title from "../../../constants/titles";

export default function RettekoderList({ authorizedToCreateAndEdit }) {
  const rettekoder = useSelector((state) => state.rettekoder);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = title.grunndataRettekoder;
    dispatch(getRettekoder());
  }, [dispatch]);

  const headerRow = ["Kode", "Navn", ""];
  return (
    <div className="table-wrapper-horizontal-scroll">
      <Table id="rettekode-liste" headerRow={headerRow} defaultStyle striped>
        <tbody>
          {map(rettekoder, (rettekode) => (
            <tr key={`rettekoderTableBodyTr${rettekode.id.toString()}`}>
              <td>{rettekode.kode}</td>
              <td>{rettekode.navn}</td>
              <td>
                {authorizedToCreateAndEdit && (
                  <RettekoderModal rettekode={rettekode} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
